import { render } from "./ElementsListing.vue?vue&type=template&id=48f20d68&scoped=true"
import script from "./ElementsListing.vue?vue&type=script&lang=js"
export * from "./ElementsListing.vue?vue&type=script&lang=js"

import "./ElementsListing.vue?vue&type=style&index=0&id=48f20d68&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f20d68"]])

export default __exports__